export const ATTACH_MEDIA_TO_PROJECT = `project/media/add`; // #!DONE
export const REMOVE_MEDIA_FROM_PROJECT = `project/media/remove`; // #!DONE